export default __webpack_public_path__ + "625dd908b7851807fad357ab021a6e18.png";